class DOMCleanup {
  constructor() {
    this.cleanupTasks = [];
  }

  // Clean up large data tables
  cleanupDataTables() {
    console.log('🧹 Cleaning up data tables...');

    // Remove large table rows
    const tables = document.querySelectorAll('.el-table, .data-table, .entity-table');
    tables.forEach((table) => {
      const tbody = table.querySelector('tbody');
      if (tbody && tbody.children.length > 100) {
        // Keep only first 50 rows, remove the rest
        const rows = Array.from(tbody.children);
        rows.slice(50).forEach((row) => {
          row.remove();
        });
        console.log(`🧹 Cleaned up table: removed ${rows.length - 50} rows`);
      }
    });
  }

  // Clean up large lists
  cleanupLargeLists() {
    console.log('🧹 Cleaning up large lists...');

    const lists = document.querySelectorAll('.el-scrollbar, .data-list, .entity-list');
    lists.forEach((list) => {
      const items = list.querySelectorAll('.list-item, .data-item, .entity-item');
      if (items.length > 200) {
        // Keep only first 100 items
        Array.from(items)
          .slice(100)
          .forEach((item) => {
            item.remove();
          });
        console.log(`🧹 Cleaned up list: removed ${items.length - 100} items`);
      }
    });
  }

  // Clean up chart components
  cleanupCharts() {
    console.log('🧹 Cleaning up charts...');

    const charts = document.querySelectorAll('.chart-container, .echarts, .chart');
    charts.forEach((chart) => {
      // Clear chart data
      if (chart.chart && chart.chart.clear) {
        chart.chart.clear();
      }

      // Remove chart canvas
      const canvas = chart.querySelector('canvas');
      if (canvas) {
        canvas.width = 0;
        canvas.height = 0;
      }
    });
  }

  // Clean up form components
  cleanupForms() {
    console.log('🧹 Cleaning up forms...');

    const forms = document.querySelectorAll('.el-form, .form-container');
    forms.forEach((form) => {
      // Clear form validation
      if (form.clearValidate) {
        form.clearValidate();
      }

      // Clear form data
      const inputs = form.querySelectorAll('input, textarea, select');
      inputs.forEach((input) => {
        if (input.type !== 'password') {
          input.value = '';
        }
      });
    });
  }

  // Clean up modal dialogs
  cleanupModals() {
    console.log('🧹 Cleaning up modals...');

    const modals = document.querySelectorAll('.el-dialog, .modal, .popup');
    modals.forEach((modal) => {
      if (modal.style.display !== 'none') {
        modal.style.display = 'none';
        modal.innerHTML = '';
      }
    });
  }

  // Clean up event listeners
  cleanupEventListeners() {
    console.log('🧹 Cleaning up event listeners...');

    // Remove global event listeners that might be holding references
    const elements = document.querySelectorAll('[data-cleanup="true"]');
    elements.forEach((element) => {
      // Clone element to remove all event listeners
      const newElement = element.cloneNode(true);
      element.parentNode.replaceChild(newElement, element);
    });
  }

  // Clean up large images
  cleanupImages() {
    console.log('🧹 Cleaning up images...');

    const images = document.querySelectorAll('img');
    images.forEach((img) => {
      // Remove large images that are not visible
      if (img.naturalWidth > 1000 && img.naturalHeight > 1000) {
        const rect = img.getBoundingClientRect();
        if (rect.top > window.innerHeight || rect.bottom < 0) {
          img.src = '';
          img.removeAttribute('src');
        }
      }
    });
  }

  // Clean up all DOM elements
  cleanupAll() {
    console.log('🧹 Starting comprehensive DOM cleanup...');

    this.cleanupDataTables();
    this.cleanupLargeLists();
    this.cleanupCharts();
    this.cleanupForms();
    this.cleanupModals();
    this.cleanupEventListeners();
    this.cleanupImages();

    // Force garbage collection if available
    if (window.gc) {
      window.gc();
    }

    console.log('✅ DOM cleanup completed');
  }

  // Clean up for specific route
  cleanupForRoute(routeName) {
    console.log(`🧹 Cleaning up DOM for route: ${routeName}`);

    switch (routeName) {
      case 'EntityData':
      case 'EntityDetailedView':
        this.cleanupDataTables();
        this.cleanupLargeLists();
        break;

      case 'Dashboard':
      case 'CustomDashboardList':
        this.cleanupCharts();
        break;

      case 'FormBuilderList':
      case 'FormBuilderUserData':
        this.cleanupForms();
        break;

      default:
        this.cleanupModals();
        this.cleanupImages();
    }
  }

  // Schedule cleanup task
  scheduleCleanup(task, delay = 1000) {
    const timeoutId = setTimeout(() => {
      task();
      this.cleanupTasks = this.cleanupTasks.filter((id) => id !== timeoutId);
    }, delay);

    this.cleanupTasks.push(timeoutId);
  }

  // Cancel all scheduled cleanups
  cancelAllCleanups() {
    this.cleanupTasks.forEach((timeoutId) => {
      clearTimeout(timeoutId);
    });
    this.cleanupTasks = [];
  }
}

export default new DOMCleanup();
